import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Desktop = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.474 14h17.052m-5.636 6s-.895 0-1.027-1.5M9.11 20s.895 0 1.027-1.5m-2.4 1.5h8.526M3.947 4h16.106c.523 0 .947.448.947 1v11c0 .552-.424 1-.947 1H3.947C3.424 17 3 16.552 3 16V5c0-.552.424-1 .947-1"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Desktop) as SvgIcon;
export { ForwardRef as ReactComponent };
